<template>
  <div class="dashboard-menu" :class="{ open: isOpen }">
    <div class="dashboard-menu__header" />

    <div v-if="needSelectOrg" class="dashboard-menu__user">
      <div class="user-info">
        <div class="drop-menu">
          <ul class="drop-menu__links">
            <li>
              <a class="drop-menu__item" role="button" @click.prevent="logout()">{{
                $t("template.signout")
              }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="!needSelectOrg" class="org-user">
      <div @click="toggleUserMenu" v-click-outside="hideUserMenu" class="user-info user-info--org">
        <div class="user-info__name">
          <img v-if="whitelabel" :src="whitelabelSrc" class="orgLogo" />
          <a href="https://charidy.com" v-else>
            <CdnLogoByLang class="logo" />
          </a>
          <p>
            {{ donorAccount && donorAccount.first_name }}
            {{ donorAccount && donorAccount.last_name }}
          </p>
        </div>
        <img src="../assets/img/arrow-down/white.png" class="white" />
        <div class="drop-menu" v-if="userMenuVisible">
          <ul class="drop-menu__links">
            <li>
              <router-link to="/user" @click.native="closeAllMenu" class="drop-menu__item">
                <span class="ico-menu ico-menu--setting">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4358 4.49717C14.2136 3.98269 13.6009 3.59219 13.0724 3.62925C12.5438 3.6663 11.9326 3.45965 11.662 3.2017C11.3913 2.94374 11.1719 2.33377 11.1918 1.80218C11.2117 1.27059 10.8029 0.674874 10.28 0.466799C9.75714 0.258725 9.0505 0.416919 8.70288 0.81454C8.35525 1.21216 7.77256 1.50432 7.40214 1.51572C7.03172 1.52712 6.4419 1.24922 6.08288 0.861571C5.72386 0.473925 5.01009 0.335684 4.49578 0.55801C3.98147 0.780336 3.58826 1.39316 3.6253 1.9219C3.66234 2.45063 3.45576 3.06203 3.19789 3.33281C2.94002 3.60359 2.33026 3.82022 1.8017 3.80312C1.27314 3.78601 0.674773 4.19361 0.466768 4.71665C0.258764 5.23968 0.416904 5.94657 0.814392 6.29431C1.21188 6.64205 1.50394 7.22494 1.51534 7.59406C1.52673 7.96318 1.25035 8.55462 0.861406 8.91377C0.472467 9.27291 0.332848 9.98549 0.557948 10.5028C0.783049 11.0202 1.39281 11.4107 1.92137 11.3736C2.44993 11.3365 3.06112 11.5432 3.33181 11.8012C3.6025 12.0591 3.8219 12.6662 3.80196 13.1978C3.78201 13.7294 4.1909 14.3251 4.71518 14.5332C5.23947 14.7413 5.94469 14.5831 6.29231 14.1855C6.63993 13.7878 7.2212 13.4957 7.59162 13.49C7.96204 13.4843 8.55186 13.7593 8.91373 14.147C9.2756 14.5346 9.98794 14.6672 10.5023 14.4448C11.0166 14.2225 11.4098 13.6125 11.3727 13.0838C11.3357 12.5551 11.5423 11.9437 11.8001 11.6729C12.058 11.4021 12.6664 11.1855 13.1978 11.2069C13.7292 11.2282 14.3247 10.8178 14.5327 10.2933C14.7407 9.76887 14.5854 9.06341 14.1851 8.71282C13.7847 8.36223 13.4927 7.78646 13.4827 7.41164C13.4727 7.03682 13.7491 6.45108 14.1395 6.09194C14.334 5.88102 14.465 5.61942 14.5175 5.33728C14.5699 5.05514 14.5416 4.76393 14.4358 4.49717ZM8.5946 10.0468C8.09114 10.2645 7.53443 10.328 6.9949 10.2291C6.45538 10.1303 5.95729 9.87358 5.56365 9.49148C5.17001 9.10937 4.89853 8.61906 4.78353 8.08257C4.66854 7.54607 4.71522 6.98752 4.91765 6.47757C5.12009 5.96762 5.46918 5.5292 5.92077 5.21777C6.37236 4.90635 6.90615 4.73592 7.45459 4.72805C8.00304 4.72018 8.54149 4.87522 9.00182 5.17355C9.46216 5.47189 9.82368 5.90012 10.0407 6.40405C10.3315 7.07845 10.3431 7.84074 10.0728 8.52365C9.80248 9.20657 9.27242 9.75434 8.59888 10.0468H8.5946Z"
                      fill="#107598"
                    />
                  </svg> </span
                >{{ $t("template.account_settings") }}
              </router-link>
            </li>

            <li v-if="showNewDashboardLink">
              <a
                :href="offer.url"
                target="_blank"
                rel="noopener"
                class="drop-menu__item !tw-flex tw-items-center"
              >
                <span class="ico-menu ico-menu--setting tw-shrink-0">
                  <svg
                    width="13"
                    height="13"
                    viewBox="0 0 13 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 1.5H11.5V9M11.5 1.5L1.5 11.5"
                      stroke="#107598"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                {{ $t("template.new_dashboard", "New Dashboard") }}
              </a>
            </li>

            <li>
              <a
                class="drop-menu__item drop-menu__item--logout"
                role="button"
                @click.prevent="logout()"
              >
                <span class="ico-menu ico-menu--logout">
                  <svg
                    width="13"
                    height="15"
                    viewBox="0 0 13 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.74532 5.31906C7.10489 5.31906 7.38956 5.03441 7.38956 4.67484V2.83204L11.2249 1.8732V13.1846L7.38956 12.2258V10.383C7.38956 10.0234 7.10489 9.73876 6.74532 9.73876C6.38575 9.73876 6.1011 10.0234 6.1011 10.383V12.7202C6.1011 13.0198 6.29587 13.2745 6.58052 13.3344L11.6894 14.6079C11.8842 14.6528 12.0789 14.6079 12.2437 14.4881C12.3935 14.3682 12.4834 14.1884 12.4834 13.9787V1.01922C12.4834 0.824459 12.3935 0.629689 12.2437 0.509833C12.1239 0.419941 11.989 0.375 11.8542 0.375C11.8092 0.375 11.7493 0.374996 11.7044 0.389978L6.5955 1.66345C6.31084 1.73836 6.11609 1.99306 6.11609 2.27772V4.61491C6.1011 5.0344 6.38575 5.31906 6.74532 5.31906Z"
                      fill="#107598"
                    />
                    <path
                      d="M0.707622 7.97092L3.37442 10.6377C3.62911 10.8924 4.03363 10.8924 4.27334 10.6377C4.52803 10.383 4.52803 9.97851 4.27334 9.7388L2.70023 8.16568H9.00766C9.36723 8.16568 9.65188 7.88103 9.65188 7.52146C9.65188 7.16189 9.36723 6.87723 9.00766 6.87723H2.68525L4.27334 5.28913C4.52803 5.03444 4.52803 4.62993 4.27334 4.39021C4.15348 4.27036 3.98868 4.21043 3.82388 4.21043C3.65908 4.21043 3.49427 4.27036 3.37442 4.39021L0.707622 7.05701C0.452928 7.32669 0.452928 7.73121 0.707622 7.97092Z"
                      fill="#107598"
                    />
                  </svg>
                </span>
                {{ $t("template.signout") }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div v-if="!needSelectOrg" class="dashboard-menu__user">
      <div @click="toggleMenu" v-click-outside="hideMenu" class="user-info user-info--dashboard">
        <div class="user-info__name">{{ account.data.attributes.name }}</div>

        <div class="user-info__avatar">
          <img :src="account.data.attributes.logo" alt="" />
        </div>

        <img src="../assets/img/arrow-down/white.png" class="white" />

        <div class="drop-menu" v-if="isVisible">
          <ul class="drop-menu__links">
            <li v-if="showOrgSearch" class="select-organizations-search" @click.stop>
              <app-search-input
                v-model="orgSearchTerm"
                :placeholder="$t('template.org_search_placeholder', 'Search org')"
              />
            </li>
            <li
              class="select-organizations"
              v-for="(organization, index) in filteredOrganizations"
              :key="index"
            >
              <div
                @click="setOrganization(organization)"
                class="drop-menu__item drop-menu__item--vs-ava"
              >
                <div class="avatar avatar--red">
                  <div class="avatar__char">U</div>
                </div>
                <span class="tw-font-sans">
                  {{ organization.attributes.name }}
                </span>
              </div>
              <div class="d-flex flex-column">
                <div
                  @click="setOrganizationSettings(organization)"
                  class="ico-menu ico-menu--setting my-1"
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4358 4.49717C14.2136 3.98269 13.6009 3.59219 13.0724 3.62925C12.5438 3.6663 11.9326 3.45965 11.662 3.2017C11.3913 2.94374 11.1719 2.33377 11.1918 1.80218C11.2117 1.27059 10.8029 0.674874 10.28 0.466799C9.75714 0.258725 9.0505 0.416919 8.70288 0.81454C8.35525 1.21216 7.77256 1.50432 7.40214 1.51572C7.03172 1.52712 6.4419 1.24922 6.08288 0.861571C5.72386 0.473925 5.01009 0.335684 4.49578 0.55801C3.98147 0.780336 3.58826 1.39316 3.6253 1.9219C3.66234 2.45063 3.45576 3.06203 3.19789 3.33281C2.94002 3.60359 2.33026 3.82022 1.8017 3.80312C1.27314 3.78601 0.674773 4.19361 0.466768 4.71665C0.258764 5.23968 0.416904 5.94657 0.814392 6.29431C1.21188 6.64205 1.50394 7.22494 1.51534 7.59406C1.52673 7.96318 1.25035 8.55462 0.861406 8.91377C0.472467 9.27291 0.332848 9.98549 0.557948 10.5028C0.783049 11.0202 1.39281 11.4107 1.92137 11.3736C2.44993 11.3365 3.06112 11.5432 3.33181 11.8012C3.6025 12.0591 3.8219 12.6662 3.80196 13.1978C3.78201 13.7294 4.1909 14.3251 4.71518 14.5332C5.23947 14.7413 5.94469 14.5831 6.29231 14.1855C6.63993 13.7878 7.2212 13.4957 7.59162 13.49C7.96204 13.4843 8.55186 13.7593 8.91373 14.147C9.2756 14.5346 9.98794 14.6672 10.5023 14.4448C11.0166 14.2225 11.4098 13.6125 11.3727 13.0838C11.3357 12.5551 11.5423 11.9437 11.8001 11.6729C12.058 11.4021 12.6664 11.1855 13.1978 11.2069C13.7292 11.2282 14.3247 10.8178 14.5327 10.2933C14.7407 9.76887 14.5854 9.06341 14.1851 8.71282C13.7847 8.36223 13.4927 7.78646 13.4827 7.41164C13.4727 7.03682 13.7491 6.45108 14.1395 6.09194C14.334 5.88102 14.465 5.61942 14.5175 5.33728C14.5699 5.05514 14.5416 4.76393 14.4358 4.49717ZM8.5946 10.0468C8.09114 10.2645 7.53443 10.328 6.9949 10.2291C6.45538 10.1303 5.95729 9.87358 5.56365 9.49148C5.17001 9.10937 4.89853 8.61906 4.78353 8.08257C4.66854 7.54607 4.71522 6.98752 4.91765 6.47757C5.12009 5.96762 5.46918 5.5292 5.92077 5.21777C6.37236 4.90635 6.90615 4.73592 7.45459 4.72805C8.00304 4.72018 8.54149 4.87522 9.00182 5.17355C9.46216 5.47189 9.82368 5.90012 10.0407 6.40405C10.3315 7.07845 10.3431 7.84074 10.0728 8.52365C9.80248 9.20657 9.27242 9.75434 8.59888 10.0468H8.5946Z"
                      fill="#107598"
                    />
                  </svg>
                </div>
                <b-badge class="my-1" variant="info" v-if="organization.id === account.data.id">
                  {{ $t("template.organization_account_active", "Active") }}
                </b-badge>
              </div>
            </li>

            <li
              v-if="showOrgSearch && filteredOrganizations.length === 0"
              class="select-organizations-empty"
            >
              <div class="drop-menu__item tw-text-gray-400 tw-font-sans">
                {{ $t("template.org_search_no_results", "No organizations found") }}
              </div>
            </li>

            <!-- Create New Organization Option -->
            <li @click.stop="openCreateOrgModal" class="create-organization-option">
              <div class="drop-menu__item--add-org" role="button">
                {{ $t("template.create_new_organization", "Create New Organization") }}
              </div>
              <span class="ico-menu ico-menu--add">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 0C3.36 0 0 3.36 0 7.5C0 11.64 3.36 15 7.5 15C11.64 15 15 11.64 15 7.5C15 3.36 11.64 0 7.5 0ZM11.25 8.25H8.25V11.25H6.75V8.25H3.75V6.75H6.75V3.75H8.25V6.75H11.25V8.25Z"
                    fill="#107598"
                  />
                </svg>
              </span>
            </li>

            <li v-if="organizationsAccount.length === 0">
              <router-link to="/account" @click.native="closeAllMenu" class="drop-menu__item">
                <span class="ico-menu ico-menu--setting">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4358 4.49717C14.2136 3.98269 13.6009 3.59219 13.0724 3.62925C12.5438 3.6663 11.9326 3.45965 11.662 3.2017C11.3913 2.94374 11.1719 2.33377 11.1918 1.80218C11.2117 1.27059 10.8029 0.674874 10.28 0.466799C9.75714 0.258725 9.0505 0.416919 8.70288 0.81454C8.35525 1.21216 7.77256 1.50432 7.40214 1.51572C7.03172 1.52712 6.4419 1.24922 6.08288 0.861571C5.72386 0.473925 5.01009 0.335684 4.49578 0.55801C3.98147 0.780336 3.58826 1.39316 3.6253 1.9219C3.66234 2.45063 3.45576 3.06203 3.19789 3.33281C2.94002 3.60359 2.33026 3.82022 1.8017 3.80312C1.27314 3.78601 0.674773 4.19361 0.466768 4.71665C0.258764 5.23968 0.416904 5.94657 0.814392 6.29431C1.21188 6.64205 1.50394 7.22494 1.51534 7.59406C1.52673 7.96318 1.25035 8.55462 0.861406 8.91377C0.472467 9.27291 0.332848 9.98549 0.557948 10.5028C0.783049 11.0202 1.39281 11.4107 1.92137 11.3736C2.44993 11.3365 3.06112 11.5432 3.33181 11.8012C3.6025 12.0591 3.8219 12.6662 3.80196 13.1978C3.78201 13.7294 4.1909 14.3251 4.71518 14.5332C5.23947 14.7413 5.94469 14.5831 6.29231 14.1855C6.63993 13.7878 7.2212 13.4957 7.59162 13.49C7.96204 13.4843 8.55186 13.7593 8.91373 14.147C9.2756 14.5346 9.98794 14.6672 10.5023 14.4448C11.0166 14.2225 11.4098 13.6125 11.3727 13.0838C11.3357 12.5551 11.5423 11.9437 11.8001 11.6729C12.058 11.4021 12.6664 11.1855 13.1978 11.2069C13.7292 11.2282 14.3247 10.8178 14.5327 10.2933C14.7407 9.76887 14.5854 9.06341 14.1851 8.71282C13.7847 8.36223 13.4927 7.78646 13.4827 7.41164C13.4727 7.03682 13.7491 6.45108 14.1395 6.09194C14.334 5.88102 14.465 5.61942 14.5175 5.33728C14.5699 5.05514 14.5416 4.76393 14.4358 4.49717ZM8.5946 10.0468C8.09114 10.2645 7.53443 10.328 6.9949 10.2291C6.45538 10.1303 5.95729 9.87358 5.56365 9.49148C5.17001 9.10937 4.89853 8.61906 4.78353 8.08257C4.66854 7.54607 4.71522 6.98752 4.91765 6.47757C5.12009 5.96762 5.46918 5.5292 5.92077 5.21777C6.37236 4.90635 6.90615 4.73592 7.45459 4.72805C8.00304 4.72018 8.54149 4.87522 9.00182 5.17355C9.46216 5.47189 9.82368 5.90012 10.0407 6.40405C10.3315 7.07845 10.3431 7.84074 10.0728 8.52365C9.80248 9.20657 9.27242 9.75434 8.59888 10.0468H8.5946Z"
                      fill="#107598"
                    />
                  </svg> </span
                >{{ $t("template.organization_settings") }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- Create Organization Modal (outside dropdown to prevent destruction) -->
      <CreateOrganizationModal
        ref="createOrgModal"
        modal-only
        @organization-created="onOrganizationCreated"
      />
    </div>

    <div class="dashboard-menu__lang">
      <b-form-select
        class="dashboard-menu__lang-select tw-font-sans tw-cursor-pointer"
        v-model="language"
        :options="languageList"
      />
    </div>

    <nav v-if="!needSelectOrg" class="dashboard-nav-wrapper">
      <ul class="dashboard-nav">
        <li>
          <router-link @click.native="sidebarMenuClose" to="/dashboard" class="dashboard-nav__link">
            <svg viewBox="0 0 27 22">
              <g fill="none" fill-rule="nonzero">
                <path
                  fill="#FFF"
                  d="M3.86 21.87c.12 0 .23-.03.34-.09 2.34-1.39 5.66-2.18 9.1-2.18 3.45 0 6.77.8 9.12 2.18.27.16.62.1.83-.14a13.1 13.1 0 1 0-19.89 0c.13.16.32.23.5.23zm2.7-4l-1.51.88a.66.66 0 0 1-.9-.24.66.66 0 0 1 .23-.9l1.5-.88a.66.66 0 1 1 .67 1.14zm16.14.59a.66.66 0 0 1-.9.24l-1.5-.86a.66.66 0 1 1 .65-1.15l1.51.87c.32.18.43.58.24.9zm1.22-5.33c0 .36-.3.66-.66.66H21.5a.66.66 0 0 1 0-1.32h1.75c.36 0 .66.3.66.66zm-3.83-4.65l1.5-.87a.66.66 0 0 1 .67 1.14l-1.51.87a.66.66 0 1 1-.66-1.14zm-3.24-2.72l.86-1.52a.66.66 0 0 1 1.15.66L18 6.4a.66.66 0 1 1-1.15-.65zm-4.2-2.59a.66.66 0 0 1 1.32 0v1.75a.66.66 0 0 1-1.32 0V3.17zm-4.5.86a.66.66 0 0 1 .9.24l.88 1.5a.66.66 0 1 1-1.14.67L7.9 4.93a.66.66 0 0 1 .24-.9zM4.3 7.9a.66.66 0 0 1 .9-.25l1.5.87a.66.66 0 1 1-.65 1.15l-1.5-.87a.66.66 0 0 1-.25-.9zm-1.6 5.23c0-.37.29-.66.65-.66H5.1a.66.66 0 0 1 0 1.32H3.35a.66.66 0 0 1-.66-.66z"
                />
                <path
                  fill="#107598"
                  d="M11.68 11.77c.75-.68 6.35-3.35 6.58-3.46a.24.24 0 0 1 .32.34c-.14.23-3.42 5.49-4.18 6.16a2.04 2.04 0 1 1-2.72-3.04z"
                />
              </g>
            </svg>
            {{ $t("template.dashboard") }}
          </router-link>
        </li>

        <li>
          <router-link @click.native="sidebarMenuClose" to="/campaign" class="dashboard-nav__link">
            <svg viewBox="0 0 27 23">
              <g fill="#FFF" fill-rule="nonzero">
                <path
                  d="M1.64 9.04v12.32c0 .9.74 1.64 1.65 1.64h3.28c.9 0 1.64-.74 1.64-1.64V4.92L4.73 6.85a3.3 3.3 0 0 1-3.09 2.19zM14 9.4L9.86 5.7v15.66c0 .9.74 1.64 1.64 1.64h3.29c.9 0 1.64-.74 1.64-1.64V12.2a3.29 3.29 0 0 1-2.44-2.79zm4.08 2.8v9.15c0 .9.74 1.64 1.64 1.64H23c.9 0 1.64-.74 1.64-1.64V5.13l-4.11 4.11a3.28 3.28 0 0 1-2.46 2.96z"
                />
                <path
                  d="M24.64 0a1.64 1.64 0 0 0-1.58 2.06l-5.39 5.4a1.6 1.6 0 0 0-.42-.07c-.18 0-.34.04-.5.09l-6.1-5.5a1.64 1.64 0 1 0-3.25-.37L2.48 4.34a1.64 1.64 0 1 0 .8 1.43L8.2 3.06c.24.15.53.24.84.24.17 0 .34-.04.5-.1l6.1 5.5a1.64 1.64 0 1 0 3.19-.08l5.4-5.39c.13.04.27.07.41.07a1.64 1.64 0 0 0 0-3.29z"
                />
              </g>
            </svg>
            {{ $t("template.campaigns") }}
          </router-link>
        </li>

        <li>
          <router-link
            @click.native="sidebarMenuClose"
            to="/media-storage"
            class="dashboard-nav__link"
          >
            <b-icon-images></b-icon-images>
            {{ $t("template.media_storage", "Media Storage") }}
          </router-link>
        </li>

        <li v-if="enablePreEventPlatform">
          <router-link
            @click.native="sidebarMenuClose"
            to="/event-donations"
            class="dashboard-nav__link"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
              <path
                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5m9.954 3H2.545c-.3 0-.545.224-.545.5v1c0 .276.244.5.545.5h10.91c.3 0 .545-.224.545-.5v-1c0-.276-.244-.5-.546-.5M11.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"
              />
            </svg>
            {{ $t("template.event-page", "Event") }}
          </router-link>
        </li>

        <li v-if="showMyContacts">
          <router-link
            to="/my-team-contacts"
            class="dashboard-nav__link"
            @click.native="sidebarMenuClose"
          >
            <icon-generic-user />
            {{ $t("donor_dashboard.my_contacts_page", "My Contacts") }}
          </router-link>
        </li>

        <li>
          <router-link @click.native="sidebarMenuClose" to="/leads" class="dashboard-nav__link">
            <svg viewBox="0 0 24 26">
              <g fill="#FFF" fill-rule="nonzero">
                <path
                  d="M7.92 22.11A3 3 0 0 0 10.76 26a3 3 0 0 0 2.84-3.89H7.92zM19.43 16.74V13.69A5.82 5.82 0 0 1 15 3.4a7.95 7.95 0 0 0-2.04-.78c.03-.12.03-.24.03-.39A2.26 2.26 0 0 0 10.76 0a2.26 2.26 0 0 0-2.24 2.24l.03.39a8.39 8.39 0 0 0-6.46 8.19v5.92A2.1 2.1 0 0 0 0 18.83c0 1.13.96 2.09 2.1 2.09h17.33c1.13 0 2.09-.96 2.09-2.1a2.1 2.1 0 0 0-2.1-2.08z"
                />
                <circle cx="18.68" cy="7.92" r="4.63" />
              </g>
            </svg>
            {{ $t("template.reminder_list") }}
          </router-link>
        </li>

        <!--emails -->
        <li v-if="emailTemplate">
          <router-link @click.native="sidebarMenuClose" to="/emails" class="dashboard-nav__link">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
              <path
                fill-rule="evenodd"
                d="M6.5 9.5 3 7.5v-6A1.5 1.5 0 0 1 4.5 0h7A1.5 1.5 0 0 1 13 1.5v6l-3.5 2L8 8.75zM1.059 3.635 2 3.133v3.753L0 5.713V5.4a2 2 0 0 1 1.059-1.765M16 5.713l-2 1.173V3.133l.941.502A2 2 0 0 1 16 5.4zm0 1.16-5.693 3.337L16 13.372v-6.5Zm-8 3.199 7.941 4.412A2 2 0 0 1 14 16H2a2 2 0 0 1-1.941-1.516zm-8 3.3 5.693-3.162L0 6.873v6.5Z"
              />
            </svg>
            {{ $t("template.emails_notice") }}
          </router-link>
        </li>
        <!--/emails -->

        <li>
          <router-link @click.native="sidebarMenuClose" to="/donations" class="dashboard-nav__link">
            <svg viewBox="0 0 24 32">
              <g fill="#FFF" fill-rule="nonzero">
                <path
                  d="M8.5 9.47A4.53 4.53 0 1 0 8.53.4a4.53 4.53 0 0 0-.01 9.07zM11.52 26.75a4.54 4.54 0 0 1 0-4.23l.04-.05a4.5 4.5 0 0 1 3.8-2.05c.7 0 1.3.26 1.92.66-1.1-5.94-5.32-9.47-8.55-9.47-3.67 0-8.69 4.67-8.69 12.35 0 .96.3 1.7.96 2.35 1.36 1.27 4.54 1.88 7.77 1.88 1.14 0 2.31-.09 3.36-.26l-.04-.3a2.73 2.73 0 0 1-.57-.88z"
                />
                <path
                  d="M23.6 26.57c.53-1.09.53-2.13-.04-3.1a3.32 3.32 0 0 0-2.88-1.56c-.91 0-1.79.82-2.4 1.4-.6-.62-1.48-1.36-2.4-1.36-1.17 0-2.22.61-2.83 1.53-.53.96-.53 2 0 3.14.48.96 1.3 1.79 1.83 2.27.74.74 2.8 2.4 3.14 2.7l.3.26.27-.21c.44-.4 2.44-2.05 3.14-2.8.7-.56 1.44-1.4 1.88-2.27z"
                />
              </g>
            </svg>
            {{ $t("template.donors") }}
          </router-link>
        </li>

        <li v-if="showExternalDonors">
          <router-link
            @click.native="sidebarMenuClose"
            to="/external-donors"
            class="dashboard-nav__link"
          >
            <svg viewBox="0 0 24 32">
              <g fill="#FFF" fill-rule="nonzero">
                <path
                  d="M8.5 9.47A4.53 4.53 0 1 0 8.53.4a4.53 4.53 0 0 0-.01 9.07zM11.52 26.75a4.54 4.54 0 0 1 0-4.23l.04-.05a4.5 4.5 0 0 1 3.8-2.05c.7 0 1.3.26 1.92.66-1.1-5.94-5.32-9.47-8.55-9.47-3.67 0-8.69 4.67-8.69 12.35 0 .96.3 1.7.96 2.35 1.36 1.27 4.54 1.88 7.77 1.88 1.14 0 2.31-.09 3.36-.26l-.04-.3a2.73 2.73 0 0 1-.57-.88z"
                />
                <path
                  d="M23.6 26.57c.53-1.09.53-2.13-.04-3.1a3.32 3.32 0 0 0-2.88-1.56c-.91 0-1.79.82-2.4 1.4-.6-.62-1.48-1.36-2.4-1.36-1.17 0-2.22.61-2.83 1.53-.53.96-.53 2 0 3.14.48.96 1.3 1.79 1.83 2.27.74.74 2.8 2.4 3.14 2.7l.3.26.27-.21c.44-.4 2.44-2.05 3.14-2.8.7-.56 1.44-1.4 1.88-2.27z"
                />
                <!-- Add an arrow to indicate external source -->
                <path
                  d="M21 10c0-1.1-.9-2-2-2h-2c-.55 0-1 .45-1 1s.45 1 1 1h1.59l-2.3 2.29c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L20 11.41V13c0 .55.45 1 1 1s1-.45 1-1v-2c0-.26-.05-.51-.15-.74-.09-.24-.23-.45-.4-.62-.18-.18-.4-.32-.65-.41-.23-.1-.48-.15-.74-.15-.01 0-.04 0-.06 0-.01 0-.04 0-.05 0"
                />
              </g>
            </svg>
            {{ $t("template.external-donors", "External Donors") }}
          </router-link>
        </li>

        <li v-if="!hasCrowdedGateway">
          <router-link @click.native="sidebarMenuClose" to="/gateways" class="dashboard-nav__link">
            <svg viewBox="0 0 27 19">
              <g fill="#FFF" fill-rule="evenodd">
                <path
                  fill-rule="nonzero"
                  d="M.14 8.15v7.04c0 1.8 1.46 3.26 3.25 3.26h20.15c1.8 0 3.25-1.46 3.25-3.26V8.15H.14zM21.4 14.9c-.53 0-.98-.26-1.26-.65-.28.4-.76.65-1.26.65a1.6 1.6 0 1 1 0-3.2c.53 0 .98.25 1.26.64.28-.36.76-.64 1.26-.64a1.6 1.6 0 1 1 0 3.2z"
                />
                <path
                  d="M23.54.22H3.39A3.25 3.25 0 0 0 .14 3.45v1.94h26.65V3.45A3.25 3.25 0 0 0 23.54.22z"
                />
              </g>
            </svg>
            {{ $t("template.gateways") }}
          </router-link>
        </li>

        <li v-if="hasCrowdedGateway">
          <b-button v-b-toggle.crowded-banking class="menu-reports">
            <svg viewBox="0 0 27 19">
              <g fill="#FFF" fill-rule="evenodd">
                <path
                  fill-rule="nonzero"
                  d="M.14 8.15v7.04c0 1.8 1.46 3.26 3.25 3.26h20.15c1.8 0 3.25-1.46 3.25-3.26V8.15H.14zM21.4 14.9c-.53 0-.98-.26-1.26-.65-.28.4-.76.65-1.26.65a1.6 1.6 0 1 1 0-3.2c.53 0 .98.25 1.26.64.28-.36.76-.64 1.26-.64a1.6 1.6 0 1 1 0 3.2z"
                />
                <path
                  d="M23.54.22H3.39A3.25 3.25 0 0 0 .14 3.45v1.94h26.65V3.45A3.25 3.25 0 0 0 23.54.22z"
                />
              </g>
            </svg>
            {{ $t("template.gateways") }}
          </b-button>
          <b-collapse id="crowded-banking" class="menu-reports-links">
            <router-link
              @click.native="sidebarMenuClose"
              to="/gateways"
              class="menu-reports-links__item"
            >
              {{ $t("template.gateways") }}
            </router-link>
            <router-link
              @click.native="sidebarMenuClose"
              to="/crowded/accounts"
              class="menu-reports-links__item"
            >
              {{ $t("template.crowded_accounts", "Crowded: Accounts") }}
            </router-link>
            <router-link
              @click.native="sidebarMenuClose"
              to="/crowded/cards"
              class="menu-reports-links__item"
            >
              {{ $t("template.crowded_cards", "Crowded: Cards") }}
            </router-link>
            <router-link
              @click.native="sidebarMenuClose"
              to="/crowded/transactions"
              class="menu-reports-links__item"
            >
              {{ $t("template.crowded_transactions", "Crowded: Transactions") }}
            </router-link>
          </b-collapse>
        </li>

        <li>
          <router-link
            @click.native="sidebarMenuClose"
            to="/charidy-app"
            class="dashboard-nav__link"
          >
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill="#FFF"
                d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
              />
            </svg>
            {{ $t("template.charidy_app", "Charidy App") }}
          </router-link>
        </li>

        <li v-if="false">
          <router-link @click.native="sidebarMenuClose" to="/billing" class="dashboard-nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style="fill: #fff"
            >
              <path
                d="M17.478,14.084c-0.348-0.609-0.89-1.144-1.624-1.603c-0.735-0.46-1.758-0.881-3.068-1.264 c-1.31-0.382-2.251-0.807-2.822-1.276C9.392,9.474,9.106,8.845,9.106,8.056c0-0.85,0.271-1.514,0.813-1.989 c0.541-0.476,1.323-0.713,2.345-0.713c0.979,0,1.758,0.321,2.333,0.964c0.27,0.301,0.476,0.651,0.62,1.05 c0.071,0.199,0.199,0.659,0.206,0.679C15.624,8.649,15.967,9,16.559,9c0.654,0,1.184-0.414,1.184-1.184 c0-0.145-0.031-0.298-0.05-0.388c-0.18-0.896-0.535-1.645-1.067-2.248c-0.804-0.91-1.927-1.455-3.371-1.632L13.25,3.547V2 c0-0.552-0.448-1-1-1s-1,0.448-1,1v1.551C9.858,3.716,8.756,4.19,7.953,4.983C7.132,5.794,6.721,6.832,6.721,8.098 c0,1.243,0.419,2.268,1.257,3.075c0.838,0.806,2.172,1.461,4.002,1.963c1.315,0.394,2.249,0.834,2.804,1.32 c0.553,0.487,0.831,1.085,0.831,1.795c0,0.842-0.323,1.506-0.967,1.992c-0.645,0.486-1.53,0.729-2.656,0.729 c-1.151,0-2.165-0.289-2.792-0.868c-0.422-0.389-0.701-0.89-0.839-1.503c-0.005-0.023-0.078-0.258-0.13-0.355 c-0.196-0.37-0.595-0.619-1.044-0.619C6.532,15.625,6,16.157,6,16.813c0,0.288,0.144,0.696,0.188,0.816 c0.225,0.615,0.59,1.174,1.047,1.625c0.883,0.869,2.225,1.37,3.765,1.517V22c0,0.552,0.447,1,0.999,1s1-0.448,1-1v-1.21l0.025-0.001 c1.572-0.147,2.795-0.617,3.667-1.413C17.563,18.581,18,17.531,18,16.227C18,15.409,17.825,14.694,17.478,14.084z"
              ></path>
            </svg>
            {{ $t("template.billing") }}
          </router-link>
        </li>

        <!-- <li>
            <router-link
              @click.native="sidebarMenuClose"
              to="/payouts"
              class="dashboard-nav__link"
            >
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              width="24" height="24"
              viewBox="0 0 24 24"
              style=" fill:#FFF;"
            >
            <path
              d="M17.478,14.084c-0.348-0.609-0.89-1.144-1.624-1.603c-0.735-0.46-1.758-0.881-3.068-1.264 c-1.31-0.382-2.251-0.807-2.822-1.276C9.392,9.474,9.106,8.845,9.106,8.056c0-0.85,0.271-1.514,0.813-1.989 c0.541-0.476,1.323-0.713,2.345-0.713c0.979,0,1.758,0.321,2.333,0.964c0.27,0.301,0.476,0.651,0.62,1.05 c0.071,0.199,0.199,0.659,0.206,0.679C15.624,8.649,15.967,9,16.559,9c0.654,0,1.184-0.414,1.184-1.184 c0-0.145-0.031-0.298-0.05-0.388c-0.18-0.896-0.535-1.645-1.067-2.248c-0.804-0.91-1.927-1.455-3.371-1.632L13.25,3.547V2 c0-0.552-0.448-1-1-1s-1,0.448-1,1v1.551C9.858,3.716,8.756,4.19,7.953,4.983C7.132,5.794,6.721,6.832,6.721,8.098 c0,1.243,0.419,2.268,1.257,3.075c0.838,0.806,2.172,1.461,4.002,1.963c1.315,0.394,2.249,0.834,2.804,1.32 c0.553,0.487,0.831,1.085,0.831,1.795c0,0.842-0.323,1.506-0.967,1.992c-0.645,0.486-1.53,0.729-2.656,0.729 c-1.151,0-2.165-0.289-2.792-0.868c-0.422-0.389-0.701-0.89-0.839-1.503c-0.005-0.023-0.078-0.258-0.13-0.355 c-0.196-0.37-0.595-0.619-1.044-0.619C6.532,15.625,6,16.157,6,16.813c0,0.288,0.144,0.696,0.188,0.816 c0.225,0.615,0.59,1.174,1.047,1.625c0.883,0.869,2.225,1.37,3.765,1.517V22c0,0.552,0.447,1,0.999,1s1-0.448,1-1v-1.21l0.025-0.001 c1.572-0.147,2.795-0.617,3.667-1.413C17.563,18.581,18,17.531,18,16.227C18,15.409,17.825,14.694,17.478,14.084z"
            >
            </path>
            </svg>
              {{ $t('template.payouts') }}
            </router-link>
          </li> -->

        <li>
          <router-link @click.native="sidebarMenuClose" to="/users" class="dashboard-nav__link">
            <icon-generic-user />
            {{ $t("template.users") }}
          </router-link>
        </li>

        <li>
          <b-button v-b-toggle.advanced class="menu-reports">
            <svg
              width="960"
              height="960"
              viewBox="0 0 960 960"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M628.833 459.92L696.429 392.324C745.265 411.713 800.379 410.507 848.436 388.71C860.235 383.357 863.058 367.866 853.896 358.704L733.52 238.329C718.895 223.704 718.895 199.991 733.52 185.366L853.771 65.114C862.992 55.892 860.156 40.287 848.274 34.911C776.762 2.554 689.668 15.763 630.885 74.545C575.672 129.757 560.806 210.52 586.267 279.503L517.341 348.429L628.833 459.92Z"
                  fill="white"
                />
                <path
                  d="M499.665 366.106L406.251 272.692L294.76 384.184L388.174 477.598L499.664 589.089L841.191 930.616C846.068 935.493 852.462 937.932 858.853 937.932C865.246 937.932 871.638 935.493 876.515 930.616L952.681 854.45C962.436 844.694 962.436 828.88 952.681 819.126L611.155 477.598L499.665 366.106Z"
                  fill="white"
                />
                <path
                  d="M904.345 127.995L804.476 227.864C796.492 235.848 796.492 248.794 804.476 256.778L881.448 333.75C890.042 342.343 904.274 341.657 911.819 332.131C956.997 275.094 965.548 198.552 937.478 134.127C931.75 120.981 914.483 117.855 904.345 127.995Z"
                  fill="white"
                />
                <path
                  d="M139.613 601.295L259.988 721.67C274.613 736.295 274.613 760.008 259.988 774.633L139.737 894.885C130.516 904.106 133.352 919.713 145.234 925.088C216.746 957.443 303.84 944.236 362.624 885.453C417.638 830.439 432.592 750.058 407.512 681.24L481.988 606.765L370.499 495.275L297.805 567.968C248.79 548.28 193.371 549.384 145.076 571.29C133.274 576.641 130.452 592.135 139.613 601.295Z"
                  fill="white"
                />
                <path
                  d="M81.69 629.866C36.513 686.903 27.962 763.446 56.031 827.87C61.758 841.016 79.025 844.141 89.164 834.003L189.033 734.134C197.017 726.15 197.017 713.204 189.033 705.22L112.061 628.249C103.468 619.655 89.235 620.34 81.69 629.866Z"
                  fill="white"
                />
                <rect
                  x="-12.2034"
                  y="309.507"
                  width="101.161"
                  height="244.878"
                  rx="30"
                  transform="rotate(-45 -12.2034 309.507)"
                  fill="white"
                />
                <path
                  d="M304.036 65.967L409.493 171.424C531.076 90.415 599.039 158.365 505.571 64.898C440.93 0.255989 359.305 30.842 304.036 65.967Z"
                  fill="white"
                />
                <path
                  d="M271.62 68.906C265.642 62.928 257.808 59.939 249.973 59.939C242.138 59.939 234.303 62.928 228.326 68.906L98.4411 198.79C86.4851 210.745 86.4851 230.129 98.4411 242.085L109.986 253.63L216.779 360.423L228.324 371.968C234.302 377.946 242.136 380.935 249.971 380.935C251.865 380.935 253.759 380.756 255.626 380.407C260 379.59 264.229 377.815 267.978 375.083C269.25 374.154 270.469 373.118 271.618 371.97L277.08 366.508L388.57 255.017L397.408 246.179L401.502 242.086C403.133 240.455 404.533 238.681 405.72 236.811C413.227 224.975 411.825 209.115 401.502 198.791L388.931 186.22L283.044 80.33L271.62 68.906Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="959.999" height="959.999" fill="white" />
                </clipPath>
              </defs>
            </svg>
            {{ $t("template.advanced", "Advanced") }}
          </b-button>
          <b-collapse
            id="advanced"
            class="menu-reports-links"
            :visible="$route.name === 'advanced'"
          >
            <router-link
              @click.native="sidebarMenuClose"
              to="/advanced/utm-links"
              class="menu-reports-links__item"
            >
              <!-- <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7 17C4.24 17 2 14.76 2 12C2 9.24 4.24 7 7 7H11V9H7C5.35 9 4 10.35 4 12C4 13.65 5.35 15 7 15H11V17H7ZM20 12C20 10.35 18.65 9 17 9H13V7H17C19.76 7 22 9.24 22 12C22 14.76 19.76 17 17 17H13V15H17C18.65 15 20 13.65 20 12ZM16 11H8V13H16V11Z"
                  fill="white"
                />
              </svg> -->
              {{ $t("template.utm_links") }}
            </router-link>

            <router-link
              v-if="showVettingApplications"
              @click.native="sidebarMenuClose"
              to="/advanced/vettings"
              class="menu-reports-links__item"
            >
              {{ $t("template.vettings") }}
            </router-link>

            <router-link
              @click.native="sidebarMenuClose"
              to="/advanced/fund-transfer-status"
              class="menu-reports-links__item"
              v-if="showFundTransferSection"
            >
              {{ $t("template.fund-transfer-status", "Fund Transfer Status") }}
            </router-link>

            <router-link
              v-if="showIntegration"
              @click.native="sidebarMenuClose"
              to="/advanced/integration"
              class="menu-reports-links__item"
            >
              <!-- remove icon  -->
              <!-- <svg viewBox="0 0 640 512">
                <path
                  fill="#FFF"
                  d="M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4a110.5 110.5 0 0 1-32.1-18.6c-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4a110.5 110.5 0 0 1 32.1 18.6c4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3a88.86 88.86 0 0 1-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8a24.05 24.05 0 0 1 10.5 29.1c-8.9 24.2-26.4 46.4-42.6 65.8a23.9 23.9 0 0 1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8a23.84 23.84 0 0 1-10.5-29c8.9-24.2 26-46.4 42.2-65.8a23.9 23.9 0 0 1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4a110.5 110.5 0 0 1-32.1-18.6c-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4a110.5 110.5 0 0 1 32.1 18.6c4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3a88.86 88.86 0 0 1-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
                />
              </svg> -->
              {{ $t("template.integration") }}
            </router-link>
          </b-collapse>
        </li>

        <li v-if="canSeeReports">
          <b-button v-b-toggle.reports class="menu-reports">
            <svg
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="file-alt"
              class="svg-inline--fa fa-file-alt fa-w-12"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path
                fill="currentColor"
                d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
              ></path>
            </svg>
            {{ $t("template.reports2", "Reports") }}
          </b-button>
          <b-collapse id="reports" class="menu-reports-links">
            <router-link
              v-for="cat in reportCategories"
              :key="cat.name"
              :to="`/reports/${cat.name}`"
              class="menu-reports-links__item"
              @click.native="sidebarMenuClose"
            >
              {{ cat.label }}
            </router-link>
          </b-collapse>
        </li>

        <li v-if="canSeeReports">
          <b-button v-b-toggle.tools class="menu-reports">
            <b-icon-gear-fill />
            {{ $t("template.tools", "Tools") }}
          </b-button>
          <b-collapse id="tools" class="menu-reports-links">
            <router-link
              @click.native="sidebarMenuClose"
              to="/reports/recurring-donations-summary"
              class="menu-reports-links__item"
            >
              {{ $t("dashboard.title_recurring_donations_summary", "Recurring donations summary") }}
            </router-link>
            <router-link
              v-for="cat in toolCategories"
              :key="cat.name"
              :to="`/reports/${cat.name}`"
              class="menu-reports-links__item"
              @click.native="sidebarMenuClose"
            >
              {{ cat.label }}
            </router-link>
          </b-collapse>
        </li>

        <li v-if="designTemplatesEnabled">
          <router-link
            @click.native="sidebarMenuClose"
            to="/design-templates"
            class="dashboard-nav__link"
          >
            <svg
              width="25"
              height="26"
              viewBox="0 0 25 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.59 14.11C10.6575 14.0522 9.74954 13.7882 8.93156 13.3368C8.11358 12.8854 7.40603 12.2581 6.86 11.5C6.79184 11.4149 6.7547 11.3091 6.7547 11.2C6.7547 11.091 6.79184 10.9852 6.86 10.9C8.24682 8.36371 9.8494 5.95145 11.65 3.69002C12.2585 2.90662 12.968 2.20719 13.76 1.61C14.0284 1.41097 14.3207 1.24636 14.63 1.12001C14.8055 1.03358 14.9996 0.992108 15.1951 0.999343C15.3906 1.00658 15.5812 1.06228 15.7497 1.16145C15.9183 1.26062 16.0596 1.40014 16.1609 1.56746C16.2622 1.73478 16.3203 1.92466 16.33 2.12001C16.4159 3.03507 16.3103 3.95801 16.02 4.83003C15.3873 6.97997 14.5467 9.06311 13.51 11.05C13.07 11.94 12.59 12.8 12.14 13.68C11.99 13.98 11.8 14.13 11.6 14.06"
                fill="white"
              />
              <path
                d="M5.34998 16.6699C5.34998 15.9799 5.34999 15.3099 5.46999 14.6699C5.58999 14.0299 5.75998 13.3999 5.92999 12.6699C7.18086 14.2075 8.96707 15.2149 10.93 15.4899C10.113 16.5752 9.03685 17.4383 7.79998 17.9999C7.98491 18.3483 8.1453 18.7092 8.27998 19.08C8.5454 20.0915 8.40923 21.1665 7.89999 22.08C7.47142 23.01 6.82982 23.8259 6.02717 24.4618C5.22452 25.0977 4.28338 25.5355 3.27998 25.7399C2.41154 25.9108 1.51225 25.8274 0.689983 25.4999C0.610676 25.483 0.537962 25.4435 0.480621 25.3862C0.42328 25.3288 0.383767 25.2561 0.366848 25.1768C0.349929 25.0975 0.356332 25.015 0.38528 24.9393C0.414229 24.8635 0.464484 24.7977 0.529983 24.7499L0.679985 24.6199C1.06297 24.314 1.34965 23.9042 1.50573 23.4395C1.6618 22.9748 1.68064 22.475 1.55999 21.9999C1.37884 21.298 1.34143 20.5667 1.44999 19.8499C1.58386 19.0662 1.95956 18.344 2.52443 17.7845C3.0893 17.2251 3.81504 16.8563 4.59998 16.7299C4.85998 16.6699 5.12999 16.63 5.35999 16.59"
                fill="white"
              />
              <path
                d="M9.75996 18.45L11.1 17.32C11.8948 17.9085 12.4435 18.7707 12.64 19.74C12.7953 20.6277 12.8523 21.5298 12.81 22.43C12.7981 22.8379 12.9359 23.2361 13.1976 23.5493C13.4592 23.8625 13.8264 24.0691 14.23 24.13C14.6802 24.1731 15.1345 24.1325 15.57 24.01C16.8573 23.6234 18.0335 22.9342 19 22C20.8703 20.318 22.0883 18.0307 22.44 15.54C22.701 14.0198 22.6568 12.4629 22.31 10.96C22.0722 9.91738 21.6171 8.93661 20.9743 8.08191C20.3316 7.22721 19.5157 6.51779 18.58 6C18.15 5.74 17.69 5.52003 17.24 5.28003L17.58 3.59998C17.8 3.67998 18.03 3.75999 18.24 3.85999C20.2552 4.7065 21.9474 6.17449 23.07 8.04999C23.7358 9.26358 24.1443 10.6014 24.27 11.98C24.6127 14.7791 24.0595 17.6149 22.69 20.08C21.3347 22.6416 19.0638 24.5983 16.33 25.56C15.4622 25.9072 14.5074 25.9736 13.6 25.75C12.8548 25.5517 12.1959 25.1129 11.7258 24.5017C11.2556 23.8905 11.0005 23.1411 11 22.37C11 21.73 11 21.09 10.94 20.45C10.9213 20.1058 10.8275 19.7698 10.6651 19.4658C10.5027 19.1617 10.2757 18.8969 9.99996 18.69L9.70996 18.45"
                fill="white"
              />
              <path
                d="M17.81 11.6699C17.4937 11.7093 17.1742 11.6284 16.9149 11.4431C16.6555 11.2579 16.4753 10.9819 16.41 10.6699C16.3802 10.3685 16.432 10.0645 16.56 9.78992C16.7756 9.37692 17.119 9.04475 17.5389 8.8429C17.9588 8.64105 18.4328 8.58035 18.89 8.66993C19.0714 8.69968 19.2437 8.77005 19.394 8.87574C19.5444 8.98143 19.669 9.1197 19.7584 9.28028C19.8478 9.44086 19.8998 9.61956 19.9105 9.80305C19.9211 9.98654 19.8902 10.1701 19.82 10.34C19.6553 10.7376 19.3786 11.0788 19.0235 11.322C18.6684 11.5653 18.2503 11.7001 17.82 11.71"
                fill="white"
              />
              <path
                d="M18.62 16.57C18.3785 16.5749 18.14 16.5155 17.9291 16.3978C17.7182 16.28 17.5425 16.1082 17.42 15.9C17.2992 15.6734 17.2472 15.4164 17.2703 15.1606C17.2934 14.9049 17.3906 14.6614 17.55 14.46C17.7893 14.1052 18.1264 13.8275 18.5205 13.6606C18.9146 13.4938 19.3487 13.4449 19.77 13.52C19.951 13.5488 20.1232 13.6181 20.2737 13.7226C20.4243 13.8271 20.5494 13.9642 20.6397 14.1236C20.73 14.2831 20.7832 14.4609 20.7954 14.6438C20.8076 14.8267 20.7784 15.0099 20.71 15.18C20.5387 15.592 20.2482 15.9435 19.8759 16.1894C19.5035 16.4352 19.0662 16.5643 18.62 16.56"
                fill="white"
              />
              <path
                d="M15.95 21.4601C15.7083 21.4661 15.4694 21.407 15.2584 21.2892C15.0473 21.1713 14.8717 20.9989 14.75 20.79C14.6306 20.5624 14.5803 20.305 14.6051 20.0492C14.63 19.7934 14.729 19.5503 14.89 19.35C15.1293 18.9952 15.4664 18.7176 15.8605 18.5507C16.2546 18.3838 16.6887 18.3349 17.11 18.41C17.2938 18.4316 17.4703 18.4948 17.6261 18.5946C17.7819 18.6945 17.9129 18.8285 18.0093 18.9865C18.1056 19.1446 18.1648 19.3224 18.1822 19.5067C18.1997 19.6909 18.175 19.8767 18.11 20.05C17.9406 20.469 17.6484 20.827 17.2718 21.0768C16.8952 21.3267 16.4519 21.4568 16 21.45"
                fill="white"
              />
            </svg>
            Design templates
          </router-link>
        </li>

        <li v-if="canSeeVideoTutorials">
          <router-link
            @click.native="sidebarMenuClose"
            to="/video-tutorials"
            class="dashboard-nav__link"
          >
            <svg
              enable-background="new 0 0 512 512"
              height="512"
              viewBox="0 0 512 512"
              width="512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <path
                  fill="currentColor"
                  d="m0 352c0 24.813 20.187 45 45 45h422c24.813 0 45-20.187 45-45v-27h-512z"
                />
                <path
                  fill="currentColor"
                  d="m396 482h-32.791l-4.262-5.327c-11.685-14.606-19.961-31.638-24.341-49.673h-157.213c-4.379 18.035-12.655 35.067-24.341 49.673l-4.261 5.327h-32.791c-8.284 0-15 6.716-15 15s6.716 15 15 15h280c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
                />
                <circle fill="currentColor" cx="126" cy="190" r="25" />
                <path
                  fill="currentColor"
                  d="m81 290v5h90v-5c0-24.813-20.187-45-45-45s-45 20.187-45 45z"
                />
                <path
                  fill="currentColor"
                  d="m227.431 95h18.569c8.284 0 15 6.716 15 15v115h170v-150h-179.569zm78.569 10h80c8.284 0 15 6.716 15 15s-6.716 15-15 15h-80c-8.284 0-15-6.716-15-15s6.716-15 15-15zm0 60h80c8.284 0 15 6.716 15 15s-6.716 15-15 15h-80c-8.284 0-15-6.716-15-15s6.716-15 15-15z"
                />
                <path
                  fill="currentColor"
                  d="m467 0h-422c-24.813 0-45 20.187-45 45v250h51v-5c0-26.383 13.705-49.61 34.358-62.983-8.915-9.779-14.358-22.774-14.358-37.017 0-30.327 24.673-55 55-55s55 24.673 55 55c0 14.243-5.443 27.238-14.358 37.017 20.653 13.373 34.358 36.6 34.358 62.983v5h311v-250c0-24.813-20.187-45-45-45zm-6 240c0 8.284-6.716 15-15 15h-200c-8.284 0-15-6.716-15-15v-115h-45c-6.315 0-11.954-3.955-14.104-9.894s-.35-12.587 4.501-16.63l60-50c2.696-2.246 6.094-3.476 9.603-3.476h200c8.284 0 15 6.716 15 15z"
                />
              </g>
            </svg>
            {{ $t("template.video_tutorials") }}
          </router-link>
        </li>

        <li v-if="donorAccount" class="tw-bg-[#50cdaa]">
          <router-link
            to="/donor-dashboard"
            class="dashboard-nav__link !tw-text-[#313131]"
            @click.native="sidebarMenuClose"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                d="M6 6.207v9.043a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H6.236a1 1 0 0 1-.447-.106l-.33-.165A.83.83 0 0 1 5 2.488V.75a.75.75 0 0 0-1.5 0v2.083c0 .715.404 1.37 1.044 1.689L5.5 5c.32.32.5.754.5 1.207"
              />
              <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
            </svg>
            {{ $t("dashboard.donor_dashboard_page", "Donor dashboard") }}
          </router-link>
        </li>
      </ul>
      <CreateDonationWithoutDashboard :class="{ open: isOpen }" @click.native="sidebarMenuClose" />
    </nav>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ClickOutside from "vue-click-outside";
import { REPORT_MENU, TOOLS_MENU, reportNames, reportOptions } from "@/constants/reports";
import iconGenericUser from "@/components/icon-genericUser.vue";
import CreateDonationWithoutDashboard from "./create-donation-without-dashboard.vue";
import CreateOrganizationModal from "./create-organization-modal.vue";
import CdnLogoByLang from "@/common-components/cdn-v2/cdn-logo-by-lang.vue";
import appSearchInput from "@/common-components/ui-elements/app-search-input.vue";
import { newDashboardOffer, loadNewDashboardOffer } from "@/helpers/new-dashboard-offer.js";

export default {
  props: {
    needSelectOrg: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isVisible: false,
      isOpen: false,
      userMenuVisible: false,
      orgSearchTerm: "",
      offer: newDashboardOffer,
    };
  },
  mounted() {
    this.$store.dispatch("getDonorAccountInfo", false);
  },

  created() {
    this.updateUserAccessSettings();
    this.updateOrgSettingsAccess();
    this.getGateways();
    loadNewDashboardOffer();
  },

  components: {
    iconGenericUser,
    CreateDonationWithoutDashboard,
    CdnLogoByLang,
    CreateOrganizationModal,
    appSearchInput,
  },

  methods: {
    // sidebar Menu
    toggleSidebar() {
      this.isOpen = !this.isOpen;
    },

    // Close sidebar and burger
    sidebarMenuClose() {
      this.isOpen = false;
      this.$emit("burger-toggle");
    },

    // user menu
    toggleMenu: function () {
      this.isVisible = !this.isVisible;
    },
    // close user menu and sidebar with burger
    closeAllMenu: function () {
      this.isVisible = true;
      this.$emit("burger-toggle");
      this.isOpen = false;
    },

    hideMenu: function () {
      this.isVisible = false;
    },
    toggleUserMenu() {
      this.userMenuVisible = !this.userMenuVisible;
    },
    hideUserMenu() {
      this.userMenuVisible = false;
    },

    logout: function () {
      this.$store.dispatch("unsetUser");
      this.$router.push({ path: "/" });
    },

    setOrganization: function (data) {
      this.$store.dispatch("changeOrganization", data.id);
    },
    setOrganizationSettings: function (data) {
      this.$store.dispatch("changeOrganizationSettings", data.id);
    },

    onOrganizationCreated: function () {
      // Close the menu after creating an organization
      this.isVisible = false;
    },

    openCreateOrgModal: function () {
      // Close the dropdown menu
      this.isVisible = false;
      // Open the modal via ref
      this.$nextTick(() => {
        this.$refs.createOrgModal.openModal();
      });
    },

    categoriesByMenu(menuName) {
      const names = [];
      reportNames
        .filter((name) => {
          if (name === "not_donated" && !this.enableOrganizationPreuploadedDonors) {
            return false;
          }

          // exclude reports
          if (this.excludedReports.includes(name)) {
            return false;
          }

          return true;
        })
        .forEach((name) => {
          const ignored = reportOptions[name].ignored || false;
          const menu = reportOptions[name].menu || menuName;
          if (!ignored && menu === menuName) {
            names.push({
              label: this.$t(`reports.category_label_${name}`, reportOptions[name].label),
              name,
            });
          }
        });
      return names;
    },

    ...mapActions({
      updateUserAccessSettings: "updateUserAccessSettings",
      updateOrgSettingsAccess: "updateOrgSettingsAccess",
      getGateways: "getGateways",
    }),
  },

  computed: {
    // The banner's offer moves here once the banner is dismissed.
    showNewDashboardLink() {
      return this.offer.switchedOn && this.offer.dismissed;
    },

    ...mapState({
      showIntegration: (state) => state.featureHide.showIntegration,
      showVettingApplications: (state) => state.featureHide.showVettingApplications,
      showMyContacts: (state) => state.featureHide.showMyContacts,
      showExternalDonors: (state) => state.featureHide.showExternalDonors,
      enableOrganizationPreuploadedDonors: (state) =>
        state.account.enableOrganizationPreuploadedDonors,
      account: (state) => state.account.account,
      whitelabel: (state) => state.account.settings?.whitelabel || false,
      whitelabelSrc: (state) => state.account.settings?.whitelogo_src || "",

      orgLogo() {
        if (this.whitelabel) {
          return this.account.data.attributes.logo;
        }
        return false;
      },

      organizationsAccount: (state) => {
        return state.account.organizations;
      },

      emailTemplate: (state) => {
        return state.account.canSeeEmailTemplates;
      },

      designTemplatesEnabled: (state) => {
        return state.account.designTemplatesEnabled && state.account.access.CanSeeDesignTemplates;
      },

      showFundTransferSection: (state) => {
        return state.account.showFundTransferSection;
      },

      canSeeReports: (state) => state.account.canSeeReports,
      canSeeVideoTutorials: (state) => state.account.canSeeTrainingVideos,
      donorAccount: (state) => state.donorAccount.account.attributes,
      excludedReports: (state) => state.featureHide.excludedReports,

      enablePreEventPlatform: (state) => state.account.enablePreEventPlatform,
      hasCrowdedGateway: (state) =>
        state.gateways.gateways.some((gw) => gw.attributes && gw.attributes.gateway === "crowded"),

      languageList: (state) => {
        let langArr = state.account.languages;

        let resultArr = [];

        for (var i = 0; i < langArr.length; i++) {
          let obj = {
            text: langArr[i].attributes.name,
            value: langArr[i].attributes.code,
          };

          resultArr.push(obj);
        }

        return resultArr;
      },
    }),

    // Bind the selector to the locale actually applied to the UI
    // (store.state.translation.locate) so it never desyncs from the
    // geo/IP-based language that App.vue applies on startup/login.
    language: {
      get() {
        return this.$store.state.translation.locate;
      },
      set(newValue) {
        this.$store.dispatch("setTranslationPermanent", newValue);
      },
    },

    reportCategories() {
      return this.categoriesByMenu(REPORT_MENU);
    },
    toolCategories() {
      return this.categoriesByMenu(TOOLS_MENU);
    },

    // Show the org search field only once the user has more than this many organizations.
    showOrgSearch() {
      return this.organizationsAccount.length > 5;
    },

    // Organizations narrowed by the current search term (case-insensitive name match).
    filteredOrganizations() {
      const term = this.orgSearchTerm.trim().toLowerCase();
      if (!term) return this.organizationsAccount;
      return this.organizationsAccount.filter((org) =>
        (org.attributes?.name || "").toLowerCase().includes(term)
      );
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
.loading {
  width: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
}

.dashboard-menu {
  width: 320px;
  overflow-y: auto;
  font-family: $vito-light;
  background-color: $bb-100;
  transition: left 0.2s ease-in-out;
  position: fixed;
  left: -320px;
  top: 90px;
  bottom: 0;
  z-index: 100;
  @media only screen and (min-width: 1280px) {
    top: 0;
    left: 0;
    width: 300px;
  }

  &.open {
    left: 0;
  }

  &__header {
    width: 100%;
    height: 90px;
    padding: 0 20px;
    align-items: center;
    justify-content: flex-start;
    background-color: $bb-90;
    display: none;
    @media only screen and (min-width: 1280px) {
      display: flex;
      height: 90px;
      justify-content: center;
    }
  }

  .orgLogo {
    display: block;
    width: auto;
    height: 80px;
  }

  .logo {
    display: block;
    width: auto;
    height: 60px;

    ::v-deep path {
      fill: white;
    }
  }

  &__user {
    height: 80px;
    padding-left: 60px;
    display: flex;
    margin-bottom: 10px;
    @media only screen and (min-width: 1280px) {
      padding-left: 40px;
    }
  }

  &__lang {
    height: 80px;
    [dir="ltr"] & {
      padding-left: 60px;
    }
    [dir="rtl"] & {
      padding-right: 60px;
    }
    display: flex;
    margin-bottom: 10px;
    @media only screen and (min-width: 1280px) {
      [dir="ltr"] & {
        padding-left: 40px;
      }
      [dir="rtl"] & {
        padding-right: 40px;
      }
    }

    ::v-deep {
      .custom-select {
        height: 60px;
        width: 200px;
        color: white;
        border: none;
        border-bottom: 1px solid rgba(255, 255, 255, 0.15);
        background: transparent url("../assets/img/arrow-down/white.png") right 0rem center/24px
          24px no-repeat;
        &:focus {
          box-shadow: none;
        }
        [dir="rtl"] & {
          background-position-x: left;
        }
        option {
          color: $fd;
        }
      }
    }
  }
}

.user-info {
  display: flex;
  width: 200px;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  position: relative;
  cursor: pointer;

  &__name {
    padding: 0 10px;
    font-size: 18px;
    line-height: 1.25;
    color: #ffffff;
    flex-grow: 2;
    max-height: 66px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  &__avatar {
    width: 44px;
    min-width: 44px;
    height: 44px;
    border-radius: 50%;
    margin-right: 5px;
    overflow: hidden;
    img {
      width: 100%;
      min-height: 100%;
      object-fit: cover;
    }
  }

  &__chevron {
    min-width: 24px;
    margin-right: 5px;
  }
  .white {
    width: 24px;
    max-width: 24px;
  }

  .drop-menu {
    margin: 0;
    padding: 5px 0px;
    background-color: #ffffff;
    position: absolute;
    z-index: 2;
    width: 280px;
    box-sizing: border-box;
    border-radius: 4px;
    top: 105%;
    left: -40px;
    box-shadow: $shadow-main;

    &__links {
      margin: 0;

      li:not(:last-of-type) {
        position: relative;
        &:after {
          content: "";
          display: block;
          width: calc(100% - 50px);
          height: 1px;
          background-color: $bg-50;
          position: absolute;
          bottom: 0px;
          left: 25px;
        }
      }
    }

    &__item {
      display: block;
      font-size: 18px;
      padding: 15px 25px;
      color: $fd;

      &:hover {
        background-color: $bg-50;
        color: $bb-100;
        text-decoration: none;
      }
      &--logout {
        color: $lr-80;
        &:hover {
          color: $lr-100;
        }
      }
      &.router-link-exact-active {
        color: $bb-100;
      }
      &--vs-ava {
        display: flex;
        max-width: 100%;
        min-height: 57px;
        padding: 0 25px;
        align-items: center;
        &:hover {
          > span {
            text-overflow: unset;
            white-space: wrap;
          }
        }
        > span {
          flex-grow: 1;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .avatar {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        margin-right: 10px;

        &--red {
          background-color: $lr-50;
          .avatar__char {
            color: $lr-100;
          }
        }

        &__char {
          display: inline-flex;
          font-family: $vito-bold;
          font-size: 14px;
          text-transform: uppercase;
          line-height: 1;
          margin-bottom: -1px;
        }
      }
    }
  }
  &--org {
    .drop-menu {
      left: -38px;
    }
  }
  &--dashboard {
    .drop-menu {
      left: -46px;
      @media only screen and (min-width: 1280px) {
        left: -37px;
      }
    }
  }
}

.select-organizations-search {
  padding: 10px 25px;
}
.select-organizations {
  display: flex;
  align-items: center;
  padding: 0.5em 0px;
  .drop-menu__item {
    flex-grow: 1;
    max-width: 80%;
    &:hover {
      background-color: #ffffff;
    }
  }
  .ico-menu {
    margin: 0 10px;
    flex-shrink: 0;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity 0.3s;
    &:hover {
      opacity: 1;
    }
  }
}
.dashboard-nav-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 75%;
}

.dashboard-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  ::v-deep button {
    font-family: $vito-light;
    background: transparent;
    background-color: transparent !important;
    margin: 0 !important;
    padding: 0;
    border: 0;
    color: #ffffff;
    &:hover {
      background-color: transparent !important;
      color: #fff;
      font-family: $vito-bold;
      text-decoration: none;
    }
  }
  ::v-deep button + div .active-link {
    color: #fff;
    font-family: $vito-bold;
  }
  ::v-deep #traning {
    padding-left: 20px;
  }
  & > * {
    padding-left: 60px;
    @media only screen and (min-width: 1280px) {
      padding-left: 40px;
    }
  }
  &__link {
    height: 56px;
    display: flex;
    align-items: center;
    font-size: 16px;
    letter-spacing: 1px;
    color: #ffffff;
    position: relative;
    &:hover {
      color: #fff;
      font-family: $vito-bold;
      text-decoration: none;
    }
    &.active-link {
      opacity: 1;
      font-family: $vito-bold;
    }
    > svg {
      width: 27px;
      height: auto;
      margin-right: 20px;
      display: block;
    }
  }
}
.menu-reports {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  > svg {
    width: 27px;
    height: auto;
    margin-right: 20px;
    display: block;
  }
}
.menu-reports-links {
  width: 100%;
  padding-right: 40px;
  display: flex;
  flex-wrap: wrap;
  &__item {
    width: 100%;
    min-height: 56px;
    padding: 5px 0 5px 30px;
    display: flex;
    align-items: center;
    color: #ffffff;
    font-family: $vito-light;
    line-height: 1.1;
    &:hover {
      text-decoration: none;
      font-family: $vito-bold;
    }
  }
}
.org-user {
  width: 200px;
  height: 90px;
  margin: 0 auto;
  @media only screen and (min-width: 1280px) {
    position: absolute;
    left: 40px;
    top: 0;
    z-index: 10;
  }
  .user-info {
    height: 90px;
    border-bottom: 0;
    &__name {
      padding: 0 5px 0 0;
      display: flex;
      align-items: center;
      img,
      a {
        display: block;
        margin-right: 10px;
      }
      p {
        font-size: 16px;
        margin: 0;
        padding: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.ico-menu {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  &--setting {
    background-color: rgba(16, 117, 152, 0.16);
  }
  &--logout {
    background-color: #ffe4e4;
  }
}
#app.he {
  .ico-menu {
    margin-right: 0;
    margin-left: 10px;
  }
  .menu-reports {
    svg {
      margin-right: initial;
      margin-left: 20px;
    }
  }
  .org-user {
    .user-info__name {
      img,
      a {
        margin-right: initial;
        margin-left: 5px;
      }
    }
  }
  .select-organizations {
    .drop-menu__item {
      position: relative;
      span {
        padding-right: initial;
        padding-left: 30px;
      }
      .ico-menu {
        position: absolute;
        right: initial;
        left: 0;
        cursor: pointer;
      }
    }
  }
}

.drop-menu__item--add-org {
  padding-inline-start: 25px;
  cursor: pointer;
  font-weight: 500;
}

.create-organization-option {
  border-top: 1px solid #eee;
  padding: 0.5em 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  .ico-menu {
    margin: 0 10px;
  }

  &:hover {
    background-color: #f5f5f5;
  }
}
</style>
